module.exports = __webpack_public_path__ + "img/brand-10.9eb2d544.png";